import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var monkeyPatchStore = function monkeyPatchStore(injector, store, values) {
  var getStatePatched = function getStatePatched() {
    return injector(store.getState(), values);
  };
  var dispatchPatched = function dispatchPatched(action) {
    if (typeof action === 'function') {
      /** monkey-patch redux-thunk */
      return store.dispatch(function (_dispatch, _getState) {
        for (var _len = arguments.length, extraArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          extraArgs[_key - 2] = arguments[_key];
        }
        return action.apply(void 0, [dispatchPatched, getStatePatched].concat(extraArgs));
      });
    }
    return store.dispatch(action);
  };
  return _objectSpread(_objectSpread({}, store), {}, {
    getState: getStatePatched,
    dispatch: dispatchPatched
  });
};